import React from "react"
import UserRow from "../UserRow"

const UsersList = ({ users, onGenerate, onRevoke, onViewDetails }) => (
  <div className="bg-white rounded-2xl border border-[#E7EAEF] divide-y divide-[#E7EAEF] overflow-hidden">
    {users.map((user) => (
      <UserRow
        key={user.id}
        user={user}
        onGenerate={onGenerate}
        onRevoke={onRevoke}
        onViewDetails={onViewDetails}
      />
    ))}
  </div>
)

export default UsersList
